import React from 'react';

import PropTypes from 'prop-types';
import Link from '@tds/core-link';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { orderStatus } from '../utils/constant';
import { getPathVariables } from '../misc';
import {
  TrackerWrapper,
  TrackerContainer,
  TrackerBlock,
  TrackerCircle,
  TrackerTextContainer,
  TrackerText,
  SignContractContainer,
  WgLabel,
  CheckMarkContainer,
  TrackerTextMobileContainer
} from './css';
import Tooltip from '../tooltip';

const Tracker = ({ orderData }) => {
  const { id, status, signature, contractUrl, wgInstallationDate } = orderData;
  const {
    contractSent,
    contractSigned,
    implementationInProgress
  } = orderStatus;
  const { origin } = window.location;
  const locale = getPathVariables(window.location.pathname)[0];

  const localizedStrings = useLocalizedStringsContext();
  const {
    orderTracking: { trackingList, signContractLabel, wgVisitLabel }
  } = localizedStrings;
  let indexOfCurrentStatus = -1;

  const isPastStatus = index => [-1, index].includes(indexOfCurrentStatus);

  const setCurrentStatusIndex = (item, index) => {
    const isCurrentStatus = item.forStatus.includes(status);
    if (isCurrentStatus) indexOfCurrentStatus = index;
    return isCurrentStatus;
  };

  const addCheckMark = () => {
    return (
      <CheckMarkContainer>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z"
            fill="#4b286d"
          />
        </svg>
      </CheckMarkContainer>
    );
  };

  const getTrackerText = (item, index) => {
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <TrackerText active={isPastStatus(index)}>
            {item.forStatus.includes(contractSigned) && signature
              ? item.label2
              : item.label}
          </TrackerText>
          {item.forStatus.includes(contractSent) &&
            status === contractSent &&
            !signature && (
              <SignContractContainer>
                <Link href={contractUrl} iconPosition="left" target="_blank">
                  {signContractLabel}
                </Link>
              </SignContractContainer>
            )}
          {item.forStatus.includes(contractSigned) && signature && (
            <SignContractContainer>
              <Link
                href={`${origin}/${locale}/view-signed-contract?id=${id}`}
                iconPosition="left"
                target="_blank"
              >
                {signContractLabel}
              </Link>
            </SignContractContainer>
          )}
          {item.forStatus.includes(implementationInProgress) &&
            wgInstallationDate && (
              <SignContractContainer>
                <WgLabel>{`${wgVisitLabel} ${wgInstallationDate}`}</WgLabel>
              </SignContractContainer>
            )}
        </div>

        {item.tooltip && (
          <Tooltip
            id={item.label}
            message={item.tooltip}
            icon="fa-info-circle"
            place="bottom"
            arrowBorderColor="#66CC00"
          ></Tooltip>
        )}
      </>
    );
  };

  return (
    <TrackerWrapper>
      <TrackerContainer style={{ display: 'flex', flexDirection: 'row' }}>
        {trackingList.map((item, index) => (
          <TrackerBlock>
            <TrackerCircle active={setCurrentStatusIndex(item, index)}>
              {isPastStatus(index) && addCheckMark()}
            </TrackerCircle>
            <TrackerTextContainer>
              {getTrackerText(item, index)}
            </TrackerTextContainer>
          </TrackerBlock>
        ))}
      </TrackerContainer>
      <TrackerTextMobileContainer>
        {trackingList.map((item, index) => (
          <>{item.forStatus.includes(status) && getTrackerText(item, index)}</>
        ))}
      </TrackerTextMobileContainer>
    </TrackerWrapper>
  );
};

Tracker.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.string).isRequired
};

export default Tracker;
